import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const DummyIcon = createValidIcon((props) => {
  const { size } = props

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid='transparent-icon'
    ></svg>
  )
})
